import qs from 'qs'
import { applicationAuth, getAuthCode, platformUrl  } from '@/api/api'
import variable from './variable'

export function getToken() {
    return localStorage.getItem('tokenValue')
}
export function getTokenName() {
    return localStorage.getItem('tokenName')
}

export function getTokenOpen() {
    return localStorage.getItem('tokenValueOpen')
}

export function getTokenNameOpen() {
    return localStorage.getItem('tokenNameOpen')
}

// 获取回调地址及身份认证code
export function getCallUrl(type='login'){
    let data = {
        enterpriseNum: variable.enterpriseNum,
        identify:variable.identify
    }
    let url = window.location.href
    applicationAuth(data).then(res => {
        if(res.code === 0) {
            let urlData = {
                response_type:'code',
                client_id:res.data.applicationId,
                redirect_uri: res.data.callBack+'?default_url='+encodeURIComponent(url)
            }
            // console.log(getAuthCode+'?'+qs.stringify(urlData))
            if(type === 'login') {
                // 跳转至获取authcode的链接
                window.location.href = getAuthCode+'?'+qs.stringify(urlData)
            }else {
                // 注册
                window.location.href = platformUrl + '/login/#/register?' + qs.stringify(urlData)
                // window.location.href = 'http:192.168.4.205:9540' + '/#/register?' + qs.stringify(urlData)
            }
            
        }
    })
}